import { authorize, deleteRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function deleteGroupAPI(id) {
  const url = `${AWS_API_URL}/2n/groups/${id}`;
  return deleteRequest(url, await authorize());
}

